import React from "react";
import "./index.css";

export const Header = () => (
  <div className="header">
    <h1>AMIR TEMUR DAVLATI</h1>
    <h1>AMIR TEMUR’S EMPIRE</h1>
  </div>
);
